/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import MuiTextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { Typography } from '../Typography';
export const TextField = ({ labelText = '', required = false, placeholder = 'Please enter the value', fullWidth = false, disabled = false, value, onChange, onKeyDown, type = 'text', error, maxLength, startIcon = null, endIcon = null, name = '', _sx = {}, className = '', inputRef, rows, multiline, dataTestId, labelColor = 'secondary', readOnly = false, inputProps, onFocus, onClick, onBlur, }) => {
    const getInputProps = () => {
        if (startIcon) {
            return {
                startAdornment: (React.createElement(InputAdornment, { position: "start" }, startIcon)),
            };
        }
        else if (endIcon) {
            return {
                endAdornment: (React.createElement(InputAdornment, { position: "start" }, endIcon)),
            };
        }
        return null;
    };
    return (React.createElement(React.Fragment, null,
        labelText && (React.createElement(Typography, { color: labelColor, variant: "subtitle1", _sx: { marginBottom: 1 } }, labelText)),
        React.createElement(MuiTextField, { sx: _sx, className: className, onKeyDown: onKeyDown, required: required, placeholder: placeholder, fullWidth: fullWidth, InputProps: getInputProps(), disabled: disabled, value: value, onChange: onChange, type: type, error: Boolean(error), helperText: error ? error : null, inputProps: Object.assign({ maxLength, readOnly }, inputProps), name: name, inputRef: inputRef, rows: rows, multiline: multiline, "data-testid": dataTestId, onFocus: onFocus, onClick: onClick, onBlur: onBlur })));
};
